import React, { useState } from "react";
import { Modal } from '@fluentui/react';
import SiteEditor from "./SiteEditor";
import PowerAppEditor from "./PowerAppEditor";
import PowerAppSolutionEditor from "./PowerAppSolutionEditor";
import PowerAppEnvironmentEditor from "./PowerAppEnvironmentEditor";

const EditModal = ({ isModalOpened, onCloseModal, itemId, callBack, isPowerAppSolution, isPowerApp, isPowerAppEnvironment, showSolutionModal, isEditable, refreshCallback}) => {

    const [isModalBlocking, setIsModalBlocking] = useState(false);

    const onEditChange = (isEditable) => {
        setIsModalBlocking(isEditable);
    };

    const onClose = () => {
        if (refreshCallback)
            refreshCallback()
        
        onCloseModal()
    }

    const editor = isPowerAppSolution ? (
        <PowerAppSolutionEditor 
            solutionId={itemId} 
            onRequestClose={onClose}
            callBack={callBack}
            isEditable={isEditable}
            onEditChange={onEditChange}
        />
    ) : isPowerApp ? (
        <PowerAppEditor
            onRequestClose={onClose}
            appId={itemId}
            callBack={callBack}
            showSolutionModal={showSolutionModal}
            onEditChange={onEditChange}
            isEditable={isEditable}
        />
    ) : isPowerAppEnvironment ? (
        <PowerAppEnvironmentEditor
            onRequestClose={onClose}
            environmentId={itemId}
            callBack={callBack}
            onEditChange={onEditChange}
            isEditable={isEditable}
        />
    ) : (
        <SiteEditor
            onRequestClose={onClose}
            siteId={itemId}
            callBack={callBack}
            onEditChange={onEditChange}
        />
    );

    return (
        <div style={{ background: 'none' }}>
            <Modal
                isOpen={isModalOpened}
                onDismiss={onClose}
                isBlocking={isModalBlocking}
                styles={modalStyles}
            >
                <div style={{ minWidth: 650, height: '100%' }}>
                    {editor}
                </div>
            </Modal>
        </div>
    );
}

export default EditModal;

const modalStyles = {
    main: {
        top: '1%',
        position: 'absolute',
        overflow: 'hidden'
    },
    scrollableContent: {
        height: '100%',
        overflow: 'hidden'
    }
};



// WEBPACK FOOTER //
// ./src/components/EditSite/EditModal.js